import { useTrackAmplitudeEvent } from 'support/amplitude/amplitudeEvent';

import ColorLabLogo from './images/instruqt-color-lab.svg';
import PoweredByLogo from './images/instruqt-powered-by.svg';
import WhiteLogo from './images/instruqt-white.svg';

export interface LogoProps {
  className?: string;
  location?: 'Notes' | 'Assignment' | 'Splash screen';
  type?: 'white' | 'color' | 'poweredBy';
  alt?: string;
  onClick?: () => void;
}

const logos = {
  color: ColorLabLogo,
  white: WhiteLogo,
  poweredBy: PoweredByLogo,
};

export const Logo = ({ className, location, type = 'white', alt = 'Instruqt', onClick }: LogoProps) => {
  const trackAmplitudeEvent = useTrackAmplitudeEvent();

  return (
    <img
      src={logos[type]}
      className={className}
      alt={alt}
      onClick={() => {
        if (location) {
          trackAmplitudeEvent({
            name: 'Lab - Logo clicked',
            data: {
              from: location,
            },
          });
        }
        onClick && onClick();
      }}
    />
  );
};
